import { useContext, useEffect, useState } from "react";

import { DisplayConfig, QueueViewState, TablePageViewState } from "@coherehealth/qm-api";
import { User, UserContext } from "UserContext";

export const queueDisplayName = (queueView: QueueViewState, displayConfig?: DisplayConfig) => {
  if (displayConfig?.title) {
    return displayConfig.title;
  }
  switch (queueView) {
    case "FAX_INTAKE":
      return "Fax Intake";
    case "RN_REVIEW":
      return "Clinical Review";
    case "MD_REVIEW":
      return "MD Review";
    case "P2P_REVIEW":
      return "P2P Review";
    case "NEW_HIRE_AUDIT_REVIEW":
      return "New Hire Audit Review";
    case "LETTER_WRITING":
      return "Letter Writing";
    case "OUTREACH":
      return "Outreach";
    default:
      return "";
  }
};

export const showSupervisorSearchConfig = (queueView: QueueViewState, tableView: TablePageViewState) => {
  switch (tableView) {
    case "SUPERVISOR_DASHBOARD":
      return true;
  }
  switch (queueView) {
    case "RN_REVIEW":
      return true;
    default:
      return false;
  }
};

export const showQphConfig = (queueView: QueueViewState) => {
  switch (queueView) {
    case "FAX_INTAKE":
      return true;
    case "LETTER_WRITING":
      return true;
    case "RN_REVIEW":
      return false;
    default:
      return false;
  }
};

export const useGetUser = () => {
  //todo - incorporate current queue into this logic, instead of reading user roles
  const { getUser } = useContext(UserContext);
  const [currentUser, setCurrentUser] = useState<User>();
  useEffect(() => {
    const setUser = async () => {
      const user = await getUser();
      if (user) {
        setCurrentUser(user);
      }
    };
    setUser();
  }, [getUser]);
  return currentUser;
};
